import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PAYMENT_METHODS_ENABLED_FOR = defineFcm('payment_methods_enabled_for')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'object',
				shape: {
					payment_method_name: {
						type: 'enum',
						values: ['creditCard', 'paypal', 'sepa', 'applePay', 'googlePay'] as const,
					},
					enabled: { type: 'boolean' },
					safe_listed_user_identifiers: { type: 'array', shape: { type: 'string' }, optional: true },
					block_listed_user_identifiers: { type: 'array', shape: { type: 'string' }, optional: true },
				},
			},
		}),
	)
	.withDefault(undefined)
	.withMerger(({ globalValue, countryValue, localeValue }) => {
		// if locale or country value, let's use them but allow global value to override their enabled state if enabled is false in the globalValue
		if (localeValue || countryValue) {
			return (localeValue || countryValue || []).map((value) => ({
				...value,
				enabled:
					(globalValue || []).find((g) => g.payment_method_name === value.payment_method_name && !g.enabled)?.enabled ??
					value.enabled,
			}));
		}
		return globalValue;
	})
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'corgi-front-end',
		context: 'Payment Form',
		description: `Displays payment method options, sequence of payment methods in the list determines the sequence in which buttons are displayed.
			Each payment method can be configured by adding:
			- payment_method_name: Should be one of the supported payment methods ('creditCard', 'paypal', 'sepa', 'applePay', 'googlePay')
			- enabled: Controls displaying of the payment method button
			- safe_listed_user_identifiers: Overrides enabled flag to display the payment method button
			- block_listed_user_identifiers: Overrides enabled flag to hide the payment method button`,
		mergeLogic: `Overrides enabled flag in country setting by configuring the payment method globally.'
			Example
				global: [{ payment_method_name: "paypal", enabled: false}]
				US: [{payment_method_name: "creditCard", enabled: true}, {payment_method_name: "paypal", enabled: true}]
				Merger value: [{payment_method_name: "creditCard", enabled: true}, {payment_method_name: "paypal", enabled: false}]`,
		import: false,
		template: [
			{
				payment_method_name: 'creditCard',
				enabled: false,
				safe_listed_user_identifiers: [],
				block_listed_user_identifiers: [],
			},
			{
				payment_method_name: 'paypal',
				enabled: false,
				safe_listed_user_identifiers: [],
				block_listed_user_identifiers: [],
			},
		],
	});
